import { useState } from 'react';
import Button from '../shared/Button.jsx';
import Reveal from '../shared/Reveal.jsx';

const FIELD_CLASS =
  'w-full rounded-[14px] border-2 border-sage bg-white px-3.5 py-3 text-[15px] text-ink outline-none transition-colors focus:border-forest';

export default function Portal() {
  const [notice, setNotice] = useState('');

  // No auth service yet — apps/api is not built. Say so rather than pretending.
  const onSubmit = (event) => {
    event.preventDefault();
    setNotice('The parent portal is not live yet. Call 0800 114 2255 and we will help.');
  };

  return (
    <section id="portal" className="bg-forest py-[70px]">
      <div className="mx-auto grid max-w-[1240px] items-center gap-12 px-5 sm:px-8 lg:grid-cols-[1.1fr_.9fr]">
        <Reveal>
          <p className="font-hand text-2xl text-sun">Already with us?</p>
          <h2 className="mt-1.5 font-display text-[clamp(26px,3.2vw,42px)] font-extrabold leading-[1.05] text-cream">
            The parent portal
          </h2>
          <p className="mt-3.5 max-w-[460px] text-[17.5px] leading-[1.6] text-sage">
            Today's photo diary, attendance, reports, lunch menu and your child's
            teacher's direct message line — all in one place.
          </p>
        </Reveal>

        <Reveal
          as="form"
          index={1}
          onSubmit={onSubmit}
          className="rounded-[30px] bg-cream p-7 shadow-[0_14px_34px_rgb(0_0_0_/_0.22)]"
        >
          <h3 className="font-display text-[22px] font-extrabold text-forest">Sign in</h3>

          <label
            htmlFor="portal-id"
            className="mb-1.5 mt-4 block text-[13px] font-bold text-ink-soft"
          >
            Email or parent ID
          </label>
          <input
            id="portal-id"
            name="identifier"
            type="text"
            autoComplete="username"
            placeholder="you@email.com"
            className={FIELD_CLASS}
          />

          <label
            htmlFor="portal-password"
            className="mb-1.5 mt-3.5 block text-[13px] font-bold text-ink-soft"
          >
            Password
          </label>
          <input
            id="portal-password"
            name="password"
            type="password"
            autoComplete="current-password"
            placeholder="••••••••"
            className={FIELD_CLASS}
          />

          <Button
            as="button"
            type="submit"
            variant="coral"
            size="md"
            block
            className="mt-[18px]"
          >
            Open my portal
          </Button>

          {notice && (
            <p role="status" className="mt-3 text-[13.5px] leading-snug text-ink-soft">
              {notice}
            </p>
          )}

          <div className="mt-3.5 flex justify-between text-[13.5px]">
            <a href="#portal" className="text-forest hover:text-coral">
              Forgot password
            </a>
            <a href="#admissions" className="text-forest hover:text-coral">
              Need an account?
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
